/**
 * De keuze tussen spel, editor en bouwer, los van de imports die erop volgen.
 *
 * Een eigen bestand omdat `entry.ts` bij het inlezen meteen een van de twee bundels haalt. Zo
 * leest `tests/editor.*.test.ts` de keuze zonder three.js of de editor aan te raken.
 */

/**
 * De weg van het spel naar de bouwer en terug: een volledige paginawissel, zodat de bouwerchunk zijn eigen opstart houdt.
 * Zonder zoekopdracht: `?level=` en `?skip=` horen bij een sortie en niet bij de bouwer.
 */
export const BUILDER_PATH = '/builder';
export const GAME_PATH = '/';

/** Of dit adres de editor vraagt: het pad `/editor`, of `?editor=1` op welk pad dan ook. */
export function wantsEditor(pathname: string, search = ''): boolean {
  if (/^\/editor(\/|$)/.test(pathname)) return true;
  return new URLSearchParams(search).get('editor') === '1';
}

/**
 * Of dit adres de levelbouwer vraagt: het pad `/builder`, of `?builder=1`.
 *
 * De bouwer draait ín het spel (`PRD-LEVEL-BUILDER.md` §4.1). `entry.ts` laadt dus gewoon
 * `main.ts`, en die vraagt dit zelf.
 */
export function wantsBuilder(pathname: string, search = ''): boolean {
  if (wantsEditor(pathname, search)) return false;
  if (/^\/builder(\/|$)/.test(pathname)) return true;
  return new URLSearchParams(search).get('builder') === '1';
}
